import { bool, number } from 'prop-types';
import { useState, useRef, useEffect } from 'react';
import {
  motion,
} from 'framer-motion';

import styles from './style.module.css';

export function Timer({ speed, finish, restart }) {
  const [ progress, setProgress ] = useState(0);
  const interval = useRef(null);
  const stopPoint = useRef(Math.floor(Math.random() * (93 - 82 + 1) + 82));

  useEffect(() => {
    if (restart) {
      setProgress(0);
      clearInterval(interval.current);
    } else if (finish) {
      clearInterval(interval.current);
      setProgress(100);
    } else {
      interval.current = setInterval(() => {
        setProgress((prev) => {
          if (prev === 100) {
            clearInterval(interval.current);
            return prev;
          }
          if (prev < stopPoint.current) {
            return prev + 1;
          }
          return prev;
        });
      }, speed * 1000);
    }

    return () => clearInterval(interval.current);
  }, [ speed, finish, restart ]);

  return (
    <div className={styles.loading}>
      <svg
        width="208"
        height="208"
        viewBox="0 0 208 208"
        fill="none"
      >
        <path stroke="#fff" strokeOpacity=".2" strokeWidth="7" d="M204 104c0 55.228-44.772 100-100 100S4 159.228 4 104 48.772 4 104 4s100 44.772 100 100Z"/>
        <motion.path initial={{
          pathLength: 0, opacity: 0,
        }}
        animate={{
          pathLength: finish ? 1 : progress / 100,
          opacity: 1,
          transition: {
            pathLength: {
              type: 'spring', duration: 1.5, bounce: 0,
            },
            opacity: { duration: 0.01 },

          },
        }}
        stroke="#fff"
        strokeWidth="7"
        d="M204 104c0 55.228-44.772 100-100 100S4 159.228 4 104 48.772 4 104 4s100 44.772 100 100Z"/>

      </svg>
      <div className={styles.percentage}>{progress}%</div>
    </div>
  );
}

Timer.propTypes = {
  speed: number.isRequired,
  finish: bool.isRequired,
  restart: bool.isRequired,
};
